import { translationsConfig } from '../../sources';
export function getAvailableTranslationOptions(userRole) {
    return (Object.keys(translationsConfig)
        .map((locale) => {
        const localeConfig = translationsConfig[locale];
        return localeConfig?.name !== undefined &&
            localeConfig.test !== true &&
            localeConfig[userRole]
            ? {
                value: locale,
                label: localeConfig.name,
            }
            : undefined;
    })
        .filter((option) => option !== undefined)
        /**
         * We need to order options by alphabetical order.
         */
        .sort((a, b) => a.label.localeCompare(b.label)));
}
//# sourceMappingURL=getAvailableTranslationOptions.js.map